import _get from 'lodash/get';
import { featuresState } from 'features/selectors';

export const accountSettingsState = state => _get(featuresState(state), 'accountSettings');